import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

// access="admin" — admin-only (Dashboard). Everything else just requires
// being signed in — both roles now use Check In/Out and Weekly Summary,
// since admins are employees too. There is still no manual view-switcher
// anywhere in the UI; which screens appear in the sidebar is still driven
// purely by isAdmin.
export default function ProtectedRoute({ access = 'any', children }) {
  const { currentUser, dataLoaded } = useApp();

  // Wait for the initial Sheets fetch + session-restore attempt to finish
  // before deciding whether to bounce to /login — otherwise a hard refresh
  // always looks "signed out" for the split second before data loads, even
  // when the saved session would have restored fine. LoadingOverlay already
  // covers the screen during this window.
  if (!dataLoaded) return null;

  if (!currentUser) return <Navigate to="/login" replace />;
  if (access === 'admin' && !currentUser.isAdmin) return <Navigate to="/checkin" replace />;

  return children;
}
